import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {LoginView} from "../views/login";
import {App} from "../app/app";
import {LogoutView} from "../views/logout";

export class LoginFunction extends AppFunction {

    readonly v : View;

    constructor(app: App) {
        super();
        this.v = new LoginView(app);
    }

    view() {
        return this.v;
    }

    url() {
        return `/login`;
    }

}

export class LogoutFunction extends AppFunction {

    readonly v : View;

    constructor(app: App) {
        super();
        this.v = new LogoutView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/logout`;
    }

}
